<template>
      <ul class="socmed">
        <li class="socmed-button facebook">
          <a href="#" @click="openSharePopup('facebook')" :title="trans('Share on Facebook')" role="button" :aria-label="trans('Share on Facebook')">
            <font-awesome-icon icon="fab fa-facebook" />
          </a>
        </li>
        <li class="socmed-button pinterest">
          <a href="#" @click="openSharePopup('pinterest')" :title="trans('Pin it on Pinterest')" role="button" :aria-label="trans('Pin it on Pinterest')">
            <font-awesome-icon icon="fab fa-pinterest-p" />
          </a>
        </li>
        <li class="socmed-button whatsapp">
          <a href="#" @click="openSharePopup('whatsapp')" :title="trans('Share on Whatsapp')" role="button" :aria-label="trans('Share on Whatsapp')">
            <font-awesome-icon icon="fab fa-whatsapp" />
          </a>
        </li>
      </ul>
</template>

<script>
import {computed} from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import config from '../config.js'
import {getImageName} from '@/composable/eonUtils'
library.add(fab)
export default {
  name: 'glassitem-share-buttons',
  itemView: "",
  props: {
    ArtNr: String,
    itemView: String,
    ColorNr: String,
    Prefix: String,
    translate: Function
  },
  setup(props) {
    const ArticleNr = computed(() => {
      return props.ArtNr
    })
    const curview = computed(() => {
      return props.itemView ? props.itemView : ""
    })
    const ColNr = computed(() => {
      return props.ColorNr
    })
    const trans = computed(() => {
      return props.translate
    })
    const prefix = computed(() => {
      return props.Prefix
    })
    return {
      ArticleNr,
      curview,
      ColNr,
      getImageName,
      config,
      trans,
      prefix
    }
  },
  methods: {
    openSharePopup: function(platform) {
      const vm = this;
      let shareUrl = '';
      switch (platform) {
        case 'facebook':
          shareUrl = 'https://facebook.com/sharer.php?display=popup';
          shareUrl += `&u=${encodeURIComponent(document.location.href)}`;
          break;
        case 'pinterest':
          shareUrl = 'https://www.pinterest.com/pin/create/link/?url=';
          shareUrl += `${encodeURIComponent(document.location.href)}`;

          shareUrl += `&media=${encodeURIComponent(this.config.glassesBaseUrl + this.getImage())}`;
          shareUrl += `&description=${encodeURIComponent('Eschenbach Eyewear - ' + this.ArticleNr + '-' + this.ColNr)}`;
          break;
        case 'whatsapp':
          shareUrl = 'https://api.whatsapp.com/send?text=';
          shareUrl += `${encodeURIComponent(document.location.href)}`;
          break;
        default:
          shareUrl = false;
      }
      if (shareUrl) {
        window.open( shareUrl, 'popup' , `width=600,height=600` );
        vm.$emit('clicked', platform);
      }
      return false;
    },
    getImage: function () {
      return config.glassesBaseUrl + this.getImageName(this.ArticleNr, this.ColNr, "pdp", this.curview)
    }
  },
  components: {
    FontAwesomeIcon
  }
}
</script>
